import { Grid } from "@mui/material";
import DataHubTable from "./components/DataHubTable";
import { useDataHubMeterDetailsDaily } from "./hooks";
import { string, func, object, number } from "prop-types";
import React from "react";
import type { Dispatch, SetStateAction } from "react";

interface MeterDetailsDailyProps {
  view: string;
  setView: Dispatch<SetStateAction<string>>;
  meteringPointId: string;
  date: any; // date object or range from NewDatePicker
  setDate: (date: any) => void;
  selectedSegment: number;
  setSelectedSegment: (segment: number) => void;
  gettext: (key: string) => string;
}

const MeterDetailsDaily = (props: MeterDetailsDailyProps) => {
  const {
    view,
    setView,
    meteringPointId,
    date,
    setDate,
    selectedSegment,
    setSelectedSegment,
    gettext,
  } = props;

  const { meterDetailDaily, loading } = useDataHubMeterDetailsDaily(
    meteringPointId,
    date,
  );

  return (
    <Grid>
      <DataHubTable
        title={view}
        setView={setView}
        view={view}
        rows={meterDetailDaily}
        selectededDate={date}
        segment={selectedSegment}
        getSelectedDate={(date: any) => {
          setDate(date);
        }}
        onSegmentChange={(selectedSegment: number) => {
          setDate(date);
          setSelectedSegment(selectedSegment);
        }}
        gettext={gettext}
        loading={loading}
      />
    </Grid>
  );
};
export default MeterDetailsDaily;

MeterDetailsDaily.propTypes = {
  view: string.isRequired,
  setView: func.isRequired,
  meteringPointId: string.isRequired,
  date: object.isRequired,
  setDate: func.isRequired,
  selectedSegment: number.isRequired,
  setSelectedSegment: func.isRequired,
  gettext: func.isRequired,
};
